import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { FilterAltOff } from '@mui/icons-material';
import DocumentFilterOption from '../documents/DocumentFilterOption';
import useSearchParams from '../hooks/useSearchParams';
import { MAT_FILTER_KEYS, MatFilterKey } from '../../types/mat-types';
import { useLocation } from 'react-router';

type Chip = { key: MatFilterKey; label: string; value: string };

const MATFilterChips: React.FC = () => {
  const { removeSearchParamSingle } = useSearchParams();
  const { search } = useLocation();
  const sp = new URLSearchParams(search);

  const chips: Chip[] = MAT_FILTER_KEYS.map((key) => ({
    key,
    label: key as string,
    value: sp.get(key) ?? '',
  }));

  const activeChips = chips.filter(({ value }) => value.trim() !== '');

  if (activeChips.length === 0) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 4 }}>
      {activeChips.map(({ key, label, value }) => (
        <DocumentFilterOption
          key={key}
          title={label}
          value={value}
          removeSearchParam={() => removeSearchParamSingle(key)}
        />
      ))}
      <Tooltip title="Clear all filters">
        <IconButton
          aria-label="clear all filters"
          size="small"
          color="primary"
          data-cy="btn-clear-all-filters"
          onClick={() => {
            MAT_FILTER_KEYS.forEach((k) => removeSearchParamSingle(k));
          }}
        >
          <FilterAltOff fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default MATFilterChips;
